/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-26 12:59:19
 * @FilePath: \hlweb2.0\src\pages\Solution\common\Customized\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import "./index.scss";
function Customized({ customizedObj }) {
  return (
    <div
      className="customized_ "
      style={customizedObj.back ? { background: customizedObj.back } : null}
    >
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{customizedObj.til}</div>
          <span>{customizedObj.dil}</span>
        </div>
      </div>
      <div
        className={
          customizedObj.margin ? "customized_img_margin" : "customized_img"
        }
      >
        <img
          style={customizedObj.width ? { width: customizedObj.width } : null}
          src={customizedObj.imgUrl}
        ></img>
      </div>
      {customizedObj.imgUrlTwo ? (
        <div className="customized_img">
          <img src={customizedObj.imgUrlTwo}></img>
        </div>
      ) : null}
    </div>
  );
}

export default Customized;
